import "./home.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import phoneCallsIcon from "../../assets/phone-calls-giz.svg";
import fasterPaymentIcon from "../../assets/faster-payment-giz.svg";
import digitalMatchingIcon from "../../assets/digital-matching-giz.svg";
import arrowIcon from "../../assets/arrow.svg";
import cartCheckIcon from "../../assets/cart-check-svgrepo-com.svg";
import truckLoadingIcon from "../../assets/truck-loading-svgrepo-com.svg";

export const Home = () => {
  const { t } = useTranslation();

  return (
    <main className="landing-page">
      <section className="hero-section">
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>{t("landing:hero.title","Logistics, Without the Friction.")}</h1>
          <p>{t("landing:hero.description","The digital gateway to 100% price transparency and zero-paperwork affiliate transport management")}</p>
          <div className="hero-cards">
            <div className="hero-card">
              <h3 className="hero-card-title hero-card-title-purchaser">
                {t("landing:hero.purchaser-title","I am a Purchaser")}
              </h3>
              <Link to="/requests/create/1" className="hero-cta hero-cta-blue">
                {t("landing:hero.purchaser-cta","Place Charge")}
              </Link>
            </div>
            <div className="hero-card">
              <h3 className="hero-card-title hero-card-title-carrier">
                {t("landing:hero.carrier-title","I am a Carrier")}
              </h3>
              <Link to="/requests/create/2" className="hero-cta hero-cta-green">
                {t("landing:hero.carrier-cta","Email Leads")}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="process-section">
        <h2>{t("landing:process.title","Stop Calling, Start Moving")}</h2>
        <div className="process-grid">
          <div className="process-item">
            <div className="process-icon">
              <img className="process-icon-img" src={phoneCallsIcon} alt="" />
            </div>
            <p>{t("landing:process.step1","Phone calls, email chains")}<br />{t("landing:process.step1.1","paper manifest")} </p>
          </div>
          <div className="process-arrow" aria-hidden="true">
            <img className="process-arrow-img" src={arrowIcon} alt="" />
          </div>
          <div className="process-item">
            <div className="process-icon">
              <img
                className="process-icon-img"
                src={digitalMatchingIcon}
                alt=""
              />
            </div>
            <p>{t("landing:process.step2","Instant digital matching")}</p>
          </div>
          <div className="process-arrow" aria-hidden="true">
            <img className="process-arrow-img" src={arrowIcon} alt="" />
          </div>
          <div className="process-item">
            <div className="process-icon">
              <img
                className="process-icon-img"
                src={fasterPaymentIcon}
                alt=""
              />
            </div>
            <p>{t("landing:process.step3","Faster Payment")}</p>
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <h2>{t("landing:benefits.title","Join the Future of Freight")}</h2>
        <div className="benefits-grid">
          <article className="benefit-card purchaser-card">
            <div className="benefit-tab purchaser-tab">
              <span className="benefit-tab-cap" aria-hidden="true">
                <img className="benefit-tab-icon-p" src={cartCheckIcon} alt="" />
              </span>
              <span>{t("landing:benefits.purchaser.title","Purchaser Benefit")}</span>
            </div>
            <div className="benefit-row">
              <span className="benefit-pill purchaser-pill">
                <span className="step-num">1</span>
                <span className="step-label">{t("landing:benefits.matching","Matching")}</span>
              </span>
              <p>{t("landing:benefits.purchaser.matching-desc","Find a truck in 15 minutes.")}</p>
            </div>
            <hr />
            <div className="benefit-row">
              <span className="benefit-pill purchaser-pill">
                <span className="step-num">2</span>
                <span className="step-label">{t("landing:benefits.payment","Payment")}</span>
              </span>
              <p>{t("landing:benefits.purchaser.payment-desc","Pay only for the service you get.")}</p>
            </div>
            <hr />
            <div className="benefit-row">
              <span className="benefit-pill purchaser-pill benefit-pill-filled">
                <span className="step-num">3</span>
                <span className="step-label">{t("landing:benefits.trust","Trust")}</span>
              </span>
              <p>{t("landing:benefits.purchaser.trust-desc","Verified drivers with ratings.")}</p>
            </div>
          </article>

          <article className="benefit-card carrier-card">
            <div className="benefit-tab carrier-tab">
              <span className="benefit-tab-cap" aria-hidden="true">
                <img className="benefit-tab-icon" src={truckLoadingIcon} alt="" />
              </span>
              <span>{t("landing:benefits.carrier.title","Carrier Benefit")}</span>
            </div>
            <div className="benefit-row">
              <span className="benefit-pill carrier-pill">
                <span className="step-num">1</span>
                <span className="step-label">{t("landing:benefits.matching","Matching")}</span>
              </span>
              <p>{t("landing:benefits.carrier.matching-desc","Find a load for your empty return.")}</p>
            </div>
            <hr />
            <div className="benefit-row">
              <span className="benefit-pill carrier-pill">
                <span className="step-num">2</span>
                <span className="step-label">{t("landing:benefits.payment","Payment")}</span>
              </span>
              <p>{t("landing:benefits.carrier.payment-desc","Get paid faster.")}</p>
            </div>
            <hr />
            <div className="benefit-row">
              <span className="benefit-pill carrier-pill benefit-pill-filled">
                <span className="step-num">3</span>
                <span className="step-label">{t("landing:benefits.trust","Trust")}</span>
              </span>
              <p>{t("landing:benefits.carrier.trust-desc","Reliable freight from verified shippers.")}</p>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
};
